import React, { useEffect } from "react";
import { Navigation } from "../components/navigation";
import { Header } from "../components/header";
import { Benefits } from "../components/benefits";
import { ChromeExtension } from "../components/chromeExtension";
import { FarmacotherapeutischKompas } from "../components/farmacotherapeutischKompas";
import { Integrations } from "../components/integrations";
import { Contact } from "../components/contact";
import { Newsletter } from "../components/newsletter";
import SmoothScroll from "smooth-scroll";
import "../App.css";
import { Pricing } from "../components/pricing";
import FAQ from "../components/faq";
import Business from "../components/business";
import { Privacy } from "../components/privacy";
import { useLanguage } from "../i18n/LanguageContext";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

export const LandingPage = () => {
  const { language, setLanguage, landing } = useLanguage();
  const landingPageData = landing;

  useEffect(() => {
    const { title, description } = landingPageData.UI.meta;
    document.title = title;

    const descriptionMeta = document.querySelector('meta[name="description"]');
    if (descriptionMeta) {
      descriptionMeta.setAttribute("content", description);
    }
  }, [landingPageData.UI.meta]);

  return (
    <div>
      <Navigation
        ui={landingPageData.UI.nav}
        language={language}
        onLanguageChange={setLanguage}
      />
      <Header data={landingPageData.Header} ui={landingPageData.UI.header} />
      <Benefits
        data={landingPageData.Benefits}
        ui={landingPageData.UI.benefits}
      />
      <Privacy ui={landingPageData.UI.privacy} />
      <ChromeExtension ui={landingPageData.UI.chromeExtension} />
      <Integrations ui={landingPageData.UI.integrations} />
      {language === "nl" && (
        <FarmacotherapeutischKompas
          ui={landingPageData.UI.farmacotherapeutischKompas}
        />
      )}
      <Pricing data={landingPageData.Pricing} ui={landingPageData.UI.pricing} />
      <Business ui={landingPageData.UI.business} />
      <Newsletter ui={landingPageData.UI.newsletter} />
      <FAQ data={landingPageData.FAQ} ui={landingPageData.UI.faq} />
      <Contact ui={landingPageData.UI.contact} />
    </div>
  );
};

export default LandingPage;
